import React, { useRef, useState } from 'react';
import { observer, inject } from 'mobx-react';
import { IInjectedProps } from '../../types';
import styles from './debugBar.scss';
import classNames from 'classnames';
import TimeMachineHost from './timeMachineHost/timeMachineHost';

const DebugBar = inject('store')(
    observer(({ store }: IInjectedProps) => {
        const [showContainer, setShowContainer] = useState(true);
        const [showTimeMachine, setShowTimeMachine] = useState(false);
        const timeMachineButtonRef = useRef<HTMLButtonElement | null>(null);

        const handleToggleClick = () => {
            setShowContainer(prev => !prev);
        };

        const handleShowDebugInfoClick = () => {
            store?.turnOnDebugger();
        }

        const handleTimemachineToggleClick = () => {
            setShowTimeMachine(prev => !prev);
        };

        return (
            <div className={classNames(
                styles.debug_bar_container,
                { [styles.hidden]: !showContainer }
            )} >
                <button className={styles.debug_bar_button} onClick={handleToggleClick}>
                    × Hide DebugBar
                </button>

                <button className={styles.debug_bar_button} onClick={handleShowDebugInfoClick}>
                    { `${!store?.debuggerIsOn ? 'Show' : 'Hide'} Debug Info` }
                </button>

                { store?.enableContentServiceForPDP &&
                    <>
                        <button
                            ref={timeMachineButtonRef}
                            className={styles.debug_bar_button}
                            onClick={handleTimemachineToggleClick}
                        >
                            {showTimeMachine ? 'Hide Timemachine' : 'Show Timemachine'}
                        </button>

                        <TimeMachineHost
                            visible={showTimeMachine}
                            anchorRef={timeMachineButtonRef}
                        />
                    </>
                }
            </div>
        );
    }
));

export default DebugBar;